<div class="modal-content">
    <!-- Cabeçalho do Modal com título e botão de fechar -->
    <div class="modal-header">
        <h5 class="modal-title">
            Adicionar Mensagem
        </h5>
        <button type="button" class="btn-close" aria-label="Fechar" (click)="activeModal.dismiss()"></button>
    </div>

    <div class="modal-body p-4">
        <form [formGroup]="mensagemForm" (ngSubmit)="adicionarMensagem()">
            <!-- Campo Feira -->
            <div class="mb-3">
                <label class="form-label">
                    Feira <span class="text-danger">*</span>
                </label>
                @if (loadingFeiras) {
                    <div class="d-flex align-items-center">
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <span>Carregando feiras...</span>
                    </div>
                } @else {
                    <select 
                        class="form-select" 
                        formControlName="feiraClienteId"
                        [ngClass]="{
                            'is-invalid':
                            mensagemForm.controls.feiraClienteId.errors &&
                            mensagemForm.get('feiraClienteId')?.touched,
                        }">
                        <option value="" selected disabled>Selecione uma feira</option>
                        <option *ngFor="let feira of listaFeiras" [value]="feira.id">
                            {{ feira.nome }}
                        </option>
                    </select>
                    <div class="invalid-feedback" *ngIf="mensagemForm.controls.feiraClienteId.errors && mensagemForm.get('feiraClienteId')?.touched">
                        Selecione uma feira.
                    </div>
                }
            </div>

            <!-- Campo Mensagem -->
            <div class="mb-3">
                <label class="form-label">
                    Mensagem <span class="text-danger">*</span>
                </label>
                <textarea 
                    class="form-control" 
                    placeholder="Digite a mensagem" 
                    formControlName="mensagem"
                    rows="3"
                    maxlength="510"
                    (input)="onInput()"
                    [ngClass]="{
                        'is-invalid':
                        mensagemForm.controls.mensagem.errors &&
                        mensagemForm.get('mensagem')?.touched,
                    }">
                </textarea>
                <div class="d-flex justify-content-between align-items-center mt-1">
                    <div class="invalid-feedback d-block" *ngIf="mensagemForm.controls.mensagem.errors && mensagemForm.get('mensagem')?.touched">
                        <span *ngIf="mensagemForm.controls.mensagem.errors['required']">A mensagem é obrigatória.</span>
                        <span *ngIf="mensagemForm.controls.mensagem.errors['maxlength']">A mensagem deve ter no máximo 510 caracteres.</span>
                    </div>
                    <small class="text-muted">{{ currentLength }} / 510 caracteres</small>
                </div>
            </div>

            <!-- Checkbox Mensagem Relevante -->
            <div class="mb-3">
                <div class="form-check">
                    <input 
                        class="form-check-input" 
                        type="checkbox" 
                        id="mensagemRelevante"
                        formControlName="mensagemRelevante">
                    <label class="form-check-label" for="mensagemRelevante">
                        Mensagem Relevante
                    </label>
                </div>
            </div>

            <!-- Botão de Enviar -->
            <div class="text-end">
                <button 
                    type="button" 
                    class="btn btn-secondary btn-sm me-2" 
                    (click)="activeModal.dismiss()"
                    [disabled]="loading">
                    Cancelar
                </button>
                <button 
                    type="submit" 
                    class="btn btn-success btn-sm w-md"
                    [disabled]="loading">
                    @if (loading) {
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    } @else {
                        Adicionar
                    }
                </button>
            </div>
        </form>
    </div>
</div>

